<template>
  <div class="ec-box">
    <div class="ec-box__item" v-for="(item, index) in data" :key="index">
      <div class="ec-box__name">
        {{item.name}}
      </div>
      <div class="ec-box__num">
        {{item.num}}
      </div>
      <div class="ec-box__status">
        <i :class="'icon--' + item.status"></i><span class="ec-box__percent">{{item.percent}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EcBox',
  props: {
    data: {
      type: [Array, Object],
      default: () => {
        return  []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ec-box {
  font-size: 0;
  &__item {
    display: inline-block;
    vertical-align: middle;
    width: 25%;
    text-align: center;
  }
  &__name {
   font-size: 14px;
   color: #fff;
   margin-bottom: 8px;
  }
  &__num {
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 8px;
  }
  &__percent {
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
  }
}
.icon {
  &--up {
    display: inline-block;
    vertical-align: middle;
    width: 9px;
    height: 17px;
    background: url(../../../assets/img/dataIndex-up.png) center no-repeat;
    -webkit-animation:  bounceDown 2s infinite;
    animation:  bounceDown 2s infinite;
  }
  &--down {
    display: inline-block;
    vertical-align: middle;
    width: 9px;
    height: 17px;
    background: url(../../../assets/img/dataIndex-down.png) center no-repeat;
    -webkit-animation:  bounceDown 2s infinite;
    animation:  bounceDown 2s infinite;
  }
  &--equal {
    display: inline-block;
    vertical-align: middle;
    width: 9px;
    height: 10px;
    background: url(../../../assets/img/dataIndex-equal.png) center no-repeat;
    -webkit-animation:  bounceDown 2s infinite;
    animation:  bounceDown 2s infinite;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataIndex/components/EcBox.vue